export enum WhatsNextOrderBy {
  MORE_RECENT = "more-recent",
  LESS_RECENT = "less-recent",
}

export interface WhatsNextFinderFiltersFormTypes {
  search: string;
  orderBy: string;
  category: string;
}
